<script setup lang="ts">
import { PRODUCT_NAME } from '../branding'
</script>

<template>
  <main class="placeholder">
    <h1>Page not found</h1>
    <p><RouterLink to="/">Back to {{ PRODUCT_NAME }}</RouterLink></p>
  </main>
</template>

<style scoped>
.placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 0.5rem;
}
h1 { margin: 0; font-size: 1.5rem; font-weight: 600; }
p  { margin: 0; color: var(--fg-muted); }
a  { color: var(--accent); }
</style>
